import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Component({
  standalone: false,
  selector: 'app-timetable-schedule',
  templateUrl: './timetable-schedule.component.html',
  styleUrls: ['./timetable-schedule.component.scss']
})
export class TimetableScheduleComponent implements OnInit {

  scheduleData: any;            // Aquí guardaremos el JSON (title, subTitle, branches, etc.)
  activeBranchIndex = 0;        // Sucursal activa (por defecto, 0)

  constructor(private http: HttpClient) { }

  ngOnInit(): void {
    this.cargarDatos();
  }

  cargarDatos(): void {
    // Ajusta la ruta a tu 'schedule.json'
    this.http.get('assets/data/schedule-data.json').subscribe((data: any) => {
      this.scheduleData = data;

      // Seleccionamos la sucursal 0 como activa, y su primera categoría como activa
      if (this.scheduleData?.branches?.length) {
        this.activeBranchIndex = 0;
        const firstBranch = this.scheduleData.branches[0];
        if (firstBranch.categories?.length) {
          // Desactiva todas las categorías y activa la primera
          firstBranch.categories.forEach((cat: any, idx: number) => {
            cat.active = (idx === 0);
          });
        }
      }
    });
  }

  /**
   * Activa la sucursal i, y reinicia sus categorías.
   */
  activarSucursal(i: number): void {
    this.activeBranchIndex = i;
    const branch = this.scheduleData.branches[i];
    if (branch.categories?.length) {
      branch.categories.forEach((cat: any, idx: number) => {
        cat.active = (idx === 0);
      });
    }
  }

  /**
   * Activa la categoría j del branch actual.
   */
  activarCategoria(branch: any, j: number): void {
    branch.categories.forEach((cat: any, idx: number) => {
      cat.active = (idx === j);
    });
  }

  /**
   * Devuelve un array con las franjas horarias únicas de la categoría,
   * sin duplicados. Asumimos que cat.timeBoxes existe y cada tb tiene
   * la propiedad `hora` de tipo string.
   */
  getUniqueTimeRanges(cat: any): string[] {
    if (!cat?.timeBoxes) return [];
    // Recolectar todas las horas
    const allHours = cat.timeBoxes.map((tb: any) => tb.hora as string);
    // Eliminar duplicados
    const unique = Array.from(new Set<string>(allHours));
    // Aquí podrías ordenarlas si deseas
    // p.ej. unique.sort(...);
    return unique;
  }

  /**
   * Retorna el timeBox que coincida con (día, franja) dentro de 'cat', o undefined si no existe.
   */
  getTimeBoxForDayAndRange(cat: any, day: string, range: string) {
    return cat.timeBoxes.find((tb: any) => tb.dia === day && tb.hora === range);
  }
}
